<template>
    <div class="five-pics-wrap" v-if="has_data" :id="target" ref="picsWrapper" :data-spm="spm">
        <h1 class="five-pics-title" v-if="tag">{{tag}}</h1>
        <div class="five-pics-list" :style="`transform: translate3D(${initPosition}px, 0, 0)`" ref="picsList">
            <div class="pics-item" v-for="(pic, index) in modifyData" :key="index">
                <a :href="pic.link ? pic.link : 'javascript:;'" onclick="return false;">
                    <img :src="pic.imageUrl" alt="">
                    <footer class="pics-title"><div class="title">{{pic.title}}</div></footer>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    import EventHelper from '../_utils/eventHelper.js'
    import Helper from '../_utils/helper.js'
    import nativeUtil from '../_utils/native-util.js'
    /**
     * @desc: 五图组件
     * 基本思想：复制开头两个元素到末尾，复制末尾两个元素到开头，形成前后共四个虚假的视觉模拟元素
     */
    export default {
        name: 'FivePics',
        props: {
            target: {
                default: '',
                type: String
            },
            data: {
                type: Array,
                default : () => [],
            },
            // 是否开启自动轮播
            loop: {
                type: Boolean,
                default: true,
            },
            // 容器动画间隔
            speed: {
                type: Number,
                default: 3000,
            },
            // 容器动画持续时间
            duration: {
                type: Number,
                default: 200,
            },
            // 起始序号
            start: {
                type: Number,
                default: 0
            },
            // 滑动距离阀值
            slideWidth: {
                type: Number,
                default: 30
            },
            // spm码
            spm:{
                default: '',
                type: String
            },
            tag: {
                default: '',
                type: String,
            }
        },
        data() {
            // 缩放比例
            const scale = parseFloat(document.documentElement.style.fontSize) / 37.5
            // 单元宽度 = 一个大图宽度 + 单边间距
            const unitWidth = 334 * scale
            // 判断初始位置是否有误, 若超过数据范围。就设置为0
            const initStart = this.start < this.data.length ? this.start : 0
            // 初始位置 = 单元宽度 + 一个大图宽度 - 单边侧图漏出宽度
            const initPosition = (-644 - unitWidth * initStart) * scale
            // 滑动距离阀值
            const slideLimit = this.slideWidth * scale
            return {
                // 初始设置为与初始位置一致
                currentPosition: initPosition * scale,
                // 最大位置，在modifyData中计算
                maxIndex: 0,
                // 初始序号
                index: initStart + 2,
                // touch事件兼容
                touchEvent: EventHelper.getTouchEvent(),
                initPosition, 
                scale,
                timer: null,
                unitWidth,
                initStart,
                slideLimit,
            }
        },
        methods: {
            // 初始化active状态
            initActive() {
                const items = this.list.querySelectorAll('.pics-item')
                Helper.addClass(items[this.index], 'active')
                this.handleShock(this.index)
            },
            // 开启自动滚动
            autoLoop() {
                if(this.timer) {
                    clearInterval(this.timer)
                } else {
                    this.setTimer()
                }
            },
            // 自动滚动的计时器
            setTimer() {
                if(this.loop) {
                    this.timer = setInterval(() => {
                        this.setTransitionDuration(this.duration)
                        this.slideNext()
                    }, this.speed)
                }
            },
            // 添加touch监听，transition监听
            addTouchListener() {
                const wrapper = this.$refs.picsWrapper
                // 监听touch
                EventHelper.addHandler(wrapper, this.touchEvent._EVT_DOWN, this.onTouchStart)
                // 监听transitionend
                EventHelper.addHandler(this.list, this.touchEvent._EVT_TRANSITIONEND, this.transitionEnd)
            },
            // touch事件
            onTouchStart(e) {
                const wrapper = this.$refs.picsWrapper
                const startX = EventHelper.getEventPos().x
                const startY = EventHelper.getEventPos().y
                const startTime = new Date().getTime()
                let moveLength = 0
                let moveLengthY = 0
                let transformLength = 0
                const onTouchMove = (e) => {
                    // 移动距离
                    moveLength = EventHelper.getEventPos().x - startX
                    moveLengthY = EventHelper.getEventPos().y - startY
                    // 如果是水平方向的移动就禁止默认操作
                    if(Math.abs(moveLength) > Math.abs(moveLengthY)) {
                        EventHelper.preventDefault(e);
                        EventHelper.stopPropagation(e);
                    }
                    // 组件transform位置
                    transformLength = this.currentPosition + moveLength
                    // 初始位置+移动距离就等于组件的滑动距离
                    this.setTransformX(transformLength)
                }
                const onTouchEnd = () => {
                    const endTime = new Date().getTime()
                    this.setTransitionDuration(this.duration)
                    if(moveLength > this.slideWidth) {
                        this.slidePrev()
                    }else if (moveLength < -(this.slideWidth)) {
                        this.slideNext()
                    }else {
                        this.setTranformIndex(this.index)
                    }
                    // 重新轮播
                    this.setTimer()
                    // 移除end事件
                    EventHelper.removeHandler(wrapper, this.touchEvent._EVT_MOVE, onTouchMove)
                    EventHelper.removeHandler(wrapper, this.touchEvent._EVT_UP, onTouchEnd)
                    // fake click时间间隔小于100且移动距离少于30时，视为点击
                    if(endTime - startTime < 100 && Math.abs(moveLength) < 30) {
                        const url = EventHelper.getTarget(e).parentNode && EventHelper.getTarget(e).parentNode.getAttribute('href') || '/'
                        nativeUtil.openContent(url)
                    }
                }
                // 停止轮播
                clearInterval(this.timer)
                EventHelper.addHandler(wrapper, this.touchEvent._EVT_MOVE, onTouchMove)
                EventHelper.addHandler(wrapper, this.touchEvent._EVT_UP, onTouchEnd)
            },
            // 后滑
            slideNext() {
                this.index = this.index + 1
            },
            // 前滑
            slidePrev() {
                this.index = this.index - 1
            },
            // 首位loop的伪造循环效果
            fakeLoop() {
                if(this.index > this.maxIndex - 2) {
                    this.index = 2
                }
                if(this.index < 2) {
                    this.index = this.maxIndex - 2
                }
            },
            // 通过位置直接设置容器的便偏移
            setTransformX(position) {
                this.list.style.transform = 'translate3D('+ position +'px, 0, 0)'
            },
            // 通过序号设置容器的偏移
            setTranformIndex(newIndex) {
                // 设置active状态
                const items = this.list.querySelectorAll('.pics-item')
                for(let i in items) {
                    if(Helper.hasClass(items[i], 'active')) {
                        Helper.removeClass(items[i], 'active')
                    }
                }
                Helper.addClass(items[newIndex], 'active')
                // 为防止视觉抖动对头尾相同的复制元素处理active
                this.handleShock(newIndex)
                // wrapper转移位置
                this.currentPosition = this.initPosition - this.unitWidth * (newIndex - this.initStart - 2)
                this.list.style.transform = 'translate3D('+ this.currentPosition +'px, 0, 0)'
            },
            // 防止视觉抖动处理
            handleShock(newIndex) {
                const items = this.list.querySelectorAll('.pics-item')
                switch (newIndex) {
                    case (newIndex, this.maxIndex - 1):
                        Helper.addClass(items[2], 'active')
                        break;
                    case (this.maxIndex - 2):
                        Helper.addClass(items[1], 'active')
                        break;
                    case 2:
                        Helper.addClass(items[this.maxIndex - 1], 'active')
                        break;
                    case 1:
                        Helper.addClass(items[this.maxIndex - 2], 'active')
                        break;
                    default:
                        break;
                }
            },
            // 设置容器的动画时间，0ms即取消
            setTransitionDuration(duration) {
                if(duration) {
                    this.list.style.transitionDuration = duration + 'ms'
                }else {
                    this.list.style.transitionDuration =  '0ms'
                }
            },
            // 容器transitionEnd事件
            transitionEnd(e) {
                // 只有list的transitionend才会进行接下来的判断
                if(EventHelper.getTarget(e).className.indexOf('five-pics-list') > -1) {
                    // 为防止逆滚动效果，取消transition
                    this.setTransitionDuration()
                    this.fakeLoop()
                }
            },
        },
        computed: {
            // 判断是否有数据，从而是否渲染
            has_data(){
                return this.data.length > 0
            },
            // 改造数据，复制首尾四项
            modifyData() {
                const data = this.data.slice()
                const len = data.length
                const first = data.slice(0, 2)
                const last = data.slice(-2)
                this.maxIndex = last.concat(data).concat(first).length - 1
                return last.concat(data).concat(first)
            }
        },
        watch: {
            index(newIndex) {
                this.setTranformIndex(newIndex)
            }
        },
        mounted() {
            this.list = this.$refs.picsList
            if(this.list) {
                this.initActive()
                this.addTouchListener()
                this.autoLoop()
            }
        }
    }
</script>

<style scoped lang="less">
    .five-pics-wrap {
        overflow: hidden;
        padding: 10px 0;
        .five-pics-title {
            margin: 2px 0 11px 11px;
            font-size: 17px; /*no*/
            font-weight: bold;
            color: #222222;
        }
        .five-pics-list {
            display: inline-flex;
            transition-property: transform;
            .pics-item {
                width: 327px;
                height: 210px;
                margin-right: 7px;
                overflow: hidden;
                position: relative;
                &.active {
                    img {
                        transform: scale(1, 1);
                        margin: 0;
                    }
                    .pics-title {
                        bottom: 0;
                    }
                }
                img {
                    transform: scale(1, 0.9);
                    border-radius: 4px;
                    max-height: 100%;
                    transition: transform ease-in-out .2s;
                }
                .pics-title {
                    position: absolute;
                    bottom: 10px;
                    width: 100%;
                    max-height: 74px;
                    box-sizing: border-box;
                    padding: 15px 18px;
                    border-radius: 4px;
                    background: linear-gradient(-180deg, rgba(0,0,0,0.00) 0%, rgba(0,0,0,0.70) 100%);
                    .title {
                        font-size: 18px;
                        line-height: 22px;
                        overflow: hidden;
                        color: #ffffff;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        word-break: break-all;
                        -webkit-box-orient: vertical;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/FivePics.vue